import React from 'react';
import { Sparkles, X } from 'lucide-react';

/**
 * A slim, dismissible notice under the header announcing a new release.
 * `release` is the newest changelog entry; Dismiss and "See what's new" both
 * count as having seen it.
 */
const ProductNotice = ({ release, onView, onDismiss, dm }) => {
  if (!release) return null;
  return (
    <div
      role="status"
      aria-label="Product notice"
      className={`relative z-20 flex items-center gap-3 px-4 py-2 text-sm border-b ${dm ? 'bg-emerald-900/40 border-emerald-700/50 text-emerald-100' : 'bg-emerald-50 border-emerald-200 text-emerald-900'}`}
    >
      <Sparkles className="w-4 h-4 shrink-0" aria-hidden="true" />
      <p className="flex-1 min-w-0">
        <strong>{release.title} is here.</strong>{' '}
        <span className="hidden sm:inline">{release.summary}</span>
      </p>
      <button
        onClick={onView}
        className="shrink-0 px-3 py-1 rounded-lg text-xs font-bold bg-emerald-600 text-white hover:bg-emerald-500"
      >
        See what's new
      </button>
      <button onClick={onDismiss} aria-label="Dismiss notice" className="shrink-0 p-1 rounded opacity-70 hover:opacity-100">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ProductNotice;
